module.exports = __webpack_public_path__ + "img/default.70f6b32c.png";